import { FormatHelper } from "../Helpers/FormatHelper.js";
import { reportError } from "../Helpers/ErrorTracker.js";

export class RequestHelper {
    /**
     * [ajax description]
     * @param  {[String]} method [description]
     * @param  {[String]} url    [description]
     * @param  {[String]} data   [JSON]
     * @return {[type]}        [description]
     */
    static ajax(method, url, data, successCallback, errorCallback) {
        let pmApiUrl = (url.includes("api.dtm") || url.includes("pmm-api")) ? true : false;
        var xhttp = new XMLHttpRequest();
        url = method.toLowerCase() == "get" ? RequestHelper.getUrl(url, data) : url;
        xhttp.open(method, url, true);
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && RequestHelper.isSuccess(this.status)) {
                // Response
                var response = this.responseText;
                if (successCallback) {
                    successCallback(response);
                }
            }
        };

        xhttp.onerror = () => {
            console.log("Error on ajax request");
            RequestHelper.reportFailure(method, url, 0);
            if (errorCallback) {
                errorCallback();
            }
        };

        xhttp.onloadend = function () {
            let response = this.responseText;
            if (xhttp.status >= 400) RequestHelper.reportFailure(method, url, xhttp.status);
            // 406: third-party hosts (e.g. DealerOn) reject our host-relative WordPress
            // calls with it; without a callback the caller hangs. 5xx deliberately left
            // out: FrontApp.setDriverConfig would render a broken widget on an API outage
            if (xhttp.status == 404 || xhttp.status == 400 || xhttp.status == 406) {
                if (errorCallback) {
                    errorCallback(response);
                }
            }
        };

        if (method.toLowerCase() == "get") {
            xhttp.send(null);
        } else {
            // add headers and stringify the data only if the request is not to save the lead
            if (!(data instanceof FormData)) {
                xhttp.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
                xhttp.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                return xhttp.send(JSON.stringify(data));
            }

            xhttp.send(data);
        }
    }

    static ajaxv2({ method, url, data = null, headers = {}, successCallback, errorCallback }) {
        var xhttp = new XMLHttpRequest();
        url = method.toLowerCase() == "get" ? RequestHelper.getUrl(url, data) : url;
        xhttp.open(method, url, true);
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && RequestHelper.isSuccess(this.status)) {
                // Response
                var response = this.responseText;
                if (successCallback) {
                    successCallback(response);
                }
            }
        };

        xhttp.onerror = () => {
            console.log("Error on ajax request");
            RequestHelper.reportFailure(method, url, 0);
            if (errorCallback) {
                errorCallback();
            }
        };

        xhttp.onloadend = function () {
            let response = this.responseText;
            if (xhttp.status >= 400) RequestHelper.reportFailure(method, url, xhttp.status);
            // 406: third-party hosts (e.g. DealerOn) reject our host-relative WordPress
            // calls with it; without a callback the caller hangs. 5xx deliberately left
            // out: FrontApp.setDriverConfig would render a broken widget on an API outage
            if (xhttp.status == 404 || xhttp.status == 400 || xhttp.status == 406) {
                if (errorCallback) {
                    errorCallback(response);
                }
            }
        };
        // Set headers
        for (let key in headers) {
            xhttp.setRequestHeader(key, headers[key]);
        }
        
        if (method.toLowerCase() == "get") {
            xhttp.send(null);
        } else {
            // add headers and stringify the data only if the request is not to save the lead
            xhttp.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            xhttp.setRequestHeader("Accept", "application/json");

            if (!(data instanceof FormData)) {
                xhttp.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
                return xhttp.send(JSON.stringify(data));
            }

            xhttp.send(data);
        }
    }

    // any 2xx: pm-motors-api on Laravel 12 answers 201 for a lead it just created, and an
    // exact 200 check called neither callback (Finish & Send spun forever, 2026-11-03)
    static isSuccess(status) {
        return status >= 200 && status < 300;
    }

    static getUrl(url, data) {
        return url + "?" + FormatHelper.serialize(data);
    }

    static getIPAddress(successCallback, errorCallback) {
        if(RequestHelper.ipAddress) {//cache
            successCallback(RequestHelper.ipAddress);
            return;
        }

        const CLOUDFLARE = "https://www.cloudflare.com/cdn-cgi/trace";
        RequestHelper.ajax("GET", CLOUDFLARE, {},  
            (cloudFlareReponse) => {                
                let ip = cloudFlareReponse
                .split("\n")
                .filter((el) => el.startsWith("ip"))
                .join("\n")
                .substring(3);
                RequestHelper.ipAddress = ip;
                successCallback(RequestHelper.ipAddress);
            }, 
            errorCallback);
    }
}

RequestHelper.ipAddress = null;

// Failed calls to our APIs -> the error tracker, when one runs (DDC only for now, see
// Helpers/ErrorTracker.js). Not the host site's own endpoints: on non-WordPress hosts the
// pm-motors-plugin calls (consent texts, accessories) fail by design.
RequestHelper.reportFailure = function (method, url, status) {
    url = String(url);
    if (url.indexOf("http") !== 0 || url.indexOf(location.origin) === 0) return;
    reportError(status ? "xhrError" : "xhrNetworkError", "XHR failed: " + method + " " + url + " -> " + (status || "network error"), { source: url, statusCode: status });
};